import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_STATE } from "../../actions/types";
import { getPropertyInfo } from '../../actions/appstate';
import { fetchDataSimple } from '../../services/data.service';
import Popover from "@mui/material/Popover";
import {
    Alert,
    Box,
    Typography,
    Chip,
    Paper, Collapse, TextField, IconButton, Button, Tooltip,
    CircularProgress
} from "@mui/material/";

import moment from 'moment';
import { DateRangePicker } from 'react-date-range';
import {
    convertToPercent, generateUniqueName, dateFormat, deepCopy, isDateInRange, keyToLabel, LabelToKey,
    userReadyOnlyStatus,
    getPermissionMessage
} from "../../app/util";

import GroupCustomCalendar from "./GroupIQCustomCalendar";
import DataService from "../../services/data.service";
import useUserLoginType from "../../hooks/useUserLoginType";




function DemandSeasons({ openSetting, openSettingTabValue, openDefault }) {
    const { app_state } = useSelector((state) => state.app.current_state);
    const dispatch = useDispatch();
    const userLoginType = useUserLoginType();
    const usrReadyOnlyStatus = userReadyOnlyStatus(userLoginType);
    const { groupIQSettings } = app_state;

    if (openDefault) {
        groupIQSettings.default_settings = {
            complimentary_rooms: "",
            per_paid_rooms: "",
            commission_percentage: "",
            profitMargins: {
                food_beverage: "",
                facilities: "",
                audio_visual: "",
                others: ""
            }
        }
        groupIQSettings.seasons = [];
    }

    useEffect(() => {
        if (openSetting === true && openSettingTabValue === 0) {
            console.log("groupIQSettings.default_settings", groupIQSettings.default_settings)
            console.log("groupIQSettings.seasons", groupIQSettings.seasons)
            console.log("openDefault", openDefault)

            if (groupIQSettings.seasons == undefined) {
                groupIQSettings.seasons = [];
            }
            if (groupIQSettings.default_settings == undefined) {
                groupIQSettings.default_settings = {
                    complimentary_rooms: 0,
                    per_paid_rooms: 0,
                    commission_percentage: 0,
                    profitMargins: {
                        food_beverage: 0,
                        facilities: 0,
                        audio_visual: 0,
                        others: 0
                    }
                }
            }
        }
    }, [openSetting, openSettingTabValue, groupIQSettings]);

    let defaultprofitMarginsTypes = [
        { name: "food_beverage", label: "Food & Beverage" },
        { name: "facilities", label: "Facilities" },
        { name: "audio_visual", label: "Audio Visual" },
        { name: "others", label: "Others" }
    ];

    //date picker functions
    const [dateRangePickerVisiblity, setDateRangePickerVisiblity] = useState(false);
    const [arrivalDate, setArrivalDate] = React.useState(moment());
    const [departureDate, setDepartureDate] = React.useState(moment().add(1, 'day'));
    const [arrivalDateTemp, setArrivalDateTemp] = React.useState(moment());
    const [departureDateTemp, setDepartureDateTemp] = React.useState(moment().add(1, 'day'));

    const [isSaving, setIsSaving] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [isSaveEnabled, setIsSaveEnabled] = useState(false);
    const [isShakeButton, setIsShakeButton] = useState(false);

    const [addButtonHidden, setAddButtonHidden] = useState(false);

    const [isChangeRequest, setIsChangeRequest] = useState(false);
    localStorage.setItem('isChanged', isChangeRequest);

    const toggleDateRangePickerVisiblity = () => {
        if (dateRangePickerVisiblity) {
            setArrivalDate(arrivalDateTemp);
            setDepartureDate(departureDateTemp);
            setDateRangePickerVisiblity(false);
        }
        else {
            setDateRangePickerVisiblity(true);
        }
    };
    const preventTyping = (e) => {
        e.preventDefault();
        return false;
    }

    const demandSeasonsdata = deepCopy(groupIQSettings.seasons);
    const defaultDemandSeasonsdata = deepCopy(groupIQSettings.default_settings);
    const newDemandSeasonData = {
        start_date: dateFormat(arrivalDateTemp, "YYYY-MM-DD"),
        end_date: dateFormat(departureDateTemp, "YYYY-MM-DD"),
        complimentary_rooms: "",
        per_paid_rooms: "",
        commission_percentage: "",
        profitMargins: {
            food_beverage: "",
            facilities: "",
            audio_visual: "",
            others: ""
        }
    }

    const demandSeasonsdataBackup = deepCopy(groupIQSettings.seasons);
    const defaultDemandSeasonsdataBackup = deepCopy(groupIQSettings.default_settings);
    const newDemandSeasonDataBackup = {
        start_date: dateFormat(arrivalDateTemp, "YYYY-MM-DD"),
        end_date: dateFormat(departureDateTemp, "YYYY-MM-DD"),
        complimentary_rooms: "",
        per_paid_rooms: "",
        commission_percentage: "",
        profitMargins: {
            food_beverage: "",
            facilities: "",
            audio_visual: "",
            others: ""
        }
    }

    const [defaultDemandSeasons, setDefaultDemandSeasons] = useState(defaultDemandSeasonsdata);
    const [demandSeasons, setDemandSeasons] = useState(demandSeasonsdata);
    const [newDemandSeasons, setNewDemandSeasons] = useState(newDemandSeasonData);

    const [expandedIndex, setExpandedIndex] = useState(null);
    const [expandedIndexDefault, setExpandedIndexDefault] = useState(openDefault ? 0 : null);

    const handleToggle = (index) => {
        if (isChanged) {
            setIsShakeButton(true);
            setTimeout(function () {
                setIsShakeButton(false);
            }, 2000); // 3000 milliseconds = 3 seconds
            return;
        }
        setExpandedIndex(expandedIndex === index ? null : index); // Toggle the clicked row
        setExpandedIndexDefault(null);
        setShowAddDemandSeason(false);
        setAddButtonHidden(false);
    };

    const handleToggleDefault = (index) => {
        if (isChanged) {
            setIsShakeButton(true);
            setTimeout(function () {
                setIsShakeButton(false);
            }, 2000); // 3000 milliseconds = 3 seconds
            return;
        }
        setExpandedIndexDefault(expandedIndexDefault === index ? null : index);
        setExpandedIndex(null);
        setShowAddDemandSeason(false)
        setAddButtonHidden(false);
    };

    const [showAddDemandSeason, setShowAddDemandSeason] = useState(false);
    function addNewDemandSeason() {
        setShowAddDemandSeason(true);
        setExpandedIndex(null);
        setExpandedIndexDefault(null);
        setAddButtonHidden(true);
    }
    function cancelNewDemandSeason() {
        setShowAddDemandSeason(false);
        setAddButtonHidden(false);
        discardChangesNew();
    }
    const addProfitMarginInput = (index) => {
        //defaultprofitMarginsTypes
        setIsChanged(true);
        setIsChangeRequest(true);
        let demandSeason = demandSeasons[index];
        let profitMarginLabels = Object.keys(demandSeason.profitMargins);
        let updatedNum = profitMarginLabels.length - 4;
        let newName = generateUniqueName("other " + (updatedNum > 0 ? updatedNum : ''));
        demandSeason.profitMargins[newName] = "";
        demandSeasons[index] = deepCopy(demandSeason);
        setDemandSeasons([...demandSeasons])

        //Empty field validation
        const hasEmptyField = emptyValueValidation(demandSeason);
        setIsSaveEnabled(hasEmptyField);
    }
    const addDefaultProfitMarginInput = () => {
        setIsChanged(true);
        setIsChangeRequest(true);
        setIsSaveEnabled(false);
        let demandSeason = { ...defaultDemandSeasons }; // create a shallow copy
        let profitMarginLabels = Object.keys(demandSeason.profitMargins);
        let updatedNum = profitMarginLabels.length - 4;
        let newName = generateUniqueName("other " + (updatedNum > 0 ? updatedNum : ''));
        demandSeason.profitMargins[newName] = ""; // add new profit margin
        setDefaultDemandSeasons(demandSeason); // update state with the modified object
    }
    const addNewProfitMarginInput = () => {
        setIsChanged(true);
        setIsChangeRequest(true);
        setIsSaveEnabled(false);
        let demandSeason = { ...newDemandSeasons }; // create a shallow copy
        let profitMarginLabels = Object.keys(demandSeason.profitMargins);
        let updatedNum = profitMarginLabels.length - 4;
        let newName = generateUniqueName("other " + (updatedNum > 0 ? updatedNum : ''));
        demandSeason.profitMargins[newName] = ""; // add new profit margin
        setNewDemandSeasons(demandSeason); // update state with the modified object
    }

    const [anchorElDots, setAnchorElDots] = React.useState(null);
    const handleClickDots = (event) => {
        setAnchorElDots(event.currentTarget);
    };
    const handleCloseDots = () => {
        setAnchorElDots(null);
    };
    const openDots = Boolean(anchorElDots);
    const idDots = openDots ? 'simple-popover' : undefined;

    const [editedMarginIndex, setEditedMarginIndex] = useState(null);
    const [editModeDefault, setEditModeDefault] = useState(false);

    // Default profit margin delete
    const deleteProfitMarginDefault = (key) => {
        // Create a copy of defaultDemandSeasons
        const updatedDemandSeasons = { ...defaultDemandSeasons };

        // Delete the profit margin
        delete updatedDemandSeasons.profitMargins[key];

        setDefaultDemandSeasons(updatedDemandSeasons)

        setIsChanged(true);
        setIsChangeRequest(true);
        handleCloseDots();

        //Empty field validation
        const hasEmptyField = emptyValueValidation(updatedDemandSeasons);
        setIsSaveEnabled(hasEmptyField);
    };
    // Default profit margin edit
    const editProfitMarginDefault = (index) => {
        setEditModeDefault(true);
        setEditedMarginIndex(index);
        handleCloseDots();
    }
    // Default profit margin rename
    const renameProfitMarginDefault = (index, newLabel) => {
        // Converting label to key
        newLabel = LabelToKey(newLabel);

        setIsChanged(true);
        setIsChangeRequest(true);

        // Create a copy of defaultDemandSeasons
        const updatedDemandSeasons = { ...defaultDemandSeasons };

        // Get the key of the margin being edited (by its index)
        const key = Object.keys(updatedDemandSeasons.profitMargins)[index];

        // Gey the current Value
        const currentValue = updatedDemandSeasons.profitMargins[key];

        // Delete the old label
        delete updatedDemandSeasons.profitMargins[key];

        // Add new label
        updatedDemandSeasons.profitMargins[newLabel] = currentValue;

        // Update the state with the new demand seasons
        setDefaultDemandSeasons(updatedDemandSeasons);

        //Empty field validation
        const hasEmptyField = emptyValueValidation(updatedDemandSeasons);
        setIsSaveEnabled(hasEmptyField);
    };

    // New profit margin delete
    const deleteProfitMarginNew = (key) => {
        // Create a copy of defaultDemandSeasons
        const updatedDemandSeasons = { ...newDemandSeasons };

        // Delete the profit margin
        delete updatedDemandSeasons.profitMargins[key];

        setNewDemandSeasons(updatedDemandSeasons)

        setIsChanged(true);
        setIsChangeRequest(true);
        handleCloseDots();

        //Empty field validation
        const hasEmptyField = emptyValueValidation(updatedDemandSeasons);
        setIsSaveEnabled(hasEmptyField);
    };
    // New profit margin edit
    const editProfitMarginNew = (index) => {
        setEditModeDefault(true);
        setEditedMarginIndex(index);
        handleCloseDots();
    }
    // New profit margin rename
    const renameProfitMarginNew = (index, newLabel) => {
        // Converting label to key
        newLabel = LabelToKey(newLabel);

        setIsChanged(true);
        setIsChangeRequest(true);

        // Create a copy of defaultDemandSeasons
        const updatedDemandSeasons = { ...newDemandSeasons };

        // Get the key of the margin being edited (by its index)
        const key = Object.keys(updatedDemandSeasons.profitMargins)[index];

        // Gey the current Value
        const currentValue = updatedDemandSeasons.profitMargins[key];

        // Delete the old label
        delete updatedDemandSeasons.profitMargins[key];

        // Add new label
        updatedDemandSeasons.profitMargins[newLabel] = currentValue;

        // Update the state with the new demand seasons
        setNewDemandSeasons(updatedDemandSeasons);

        //Empty field validation
        const hasEmptyField = emptyValueValidation(updatedDemandSeasons);
        setIsSaveEnabled(hasEmptyField);
    };

    // Profit margin delete
    const deleteProfitMargin = (i, key) => {
        // Create a copy of defaultDemandSeasons
        const updatedDemandSeasons = [...demandSeasons];

        // Delete the profit margin
        delete updatedDemandSeasons[i].profitMargins[key];

        setDemandSeasons(updatedDemandSeasons);
        setIsChanged(true);
        setIsChangeRequest(true);
        handleCloseDots();

        //Empty field validation
        const hasEmptyField = emptyValueValidation(updatedDemandSeasons[i]);
        setIsSaveEnabled(hasEmptyField);
    };
    // Profit margin edit
    const editProfitMargin = (i, index) => {
        setEditModeDefault(true);
        setEditedMarginIndex(index);
        handleCloseDots();
    }
    // Profit margin rename
    const renameProfitMargin = (i, index, newLabel) => {
        // Converting label to key
        newLabel = LabelToKey(newLabel);

        setIsChanged(true);
        setIsChangeRequest(true);

        // Create a copy of defaultDemandSeasons
        const updatedDemandSeasons = [...demandSeasons];

        // Get the key of the margin being edited (by its index)
        const key = Object.keys(updatedDemandSeasons[i].profitMargins)[index];

        // Gey the current Value
        const currentValue = updatedDemandSeasons[i].profitMargins[key];

        // Delete the old label
        delete updatedDemandSeasons[i].profitMargins[key];

        // Add new label
        updatedDemandSeasons[i].profitMargins[newLabel] = currentValue;

        // Update the state with the new demand seasons
        setDemandSeasons(updatedDemandSeasons);

        //Empty field validation
        const hasEmptyField = emptyValueValidation(updatedDemandSeasons[i]);
        setIsSaveEnabled(hasEmptyField);
    };

    const discardChangesDefault = () => {
        setDefaultDemandSeasons(defaultDemandSeasonsdataBackup);
        setIsChanged(false);
        setIsChangeRequest(false);
        setIsSaveEnabled(false);
    }
    const discardChangesNew = () => {
        setNewDemandSeasons(newDemandSeasonDataBackup);
        setIsChanged(false);
        setIsChangeRequest(false);
        setIsSaveEnabled(false);
        setArrivalDate(moment());
        setDepartureDate(moment().add(1, 'day'))
        setArrivalDateTemp(moment());
        setDepartureDateTemp(moment().add(1, 'day'))
    }
    const discardChanges = () => {
        setDemandSeasons(demandSeasonsdataBackup);
        setIsChanged(false);
        setIsChangeRequest(false);
        setIsSaveEnabled(false);
    }

    const [alertText, setAlertText] = useState("");
    const showAlert = async (date) => {
        setAlertText(dateFormat(date, "DD MMM, YY") + " is overlaping with existing seasons.");
        let alertContainer = document.getElementsByClassName("save-changes-alert-settings");
        if (alertContainer.length > 0) {
            alertContainer[0].className = alertContainer[0].className.replace("display-none", "").trim();
            setTimeout(() => {
                alertContainer[0].className += " display-none";
            }, 4000);
        }
    }

    // Create New Demand seasons POST API
    const createDemandSeason = async () => {
        const updatedDemandSeasons = { ...newDemandSeasons };
        updatedDemandSeasons.start_date = dateFormat(arrivalDate, "YYYY-MM-DD")
        updatedDemandSeasons.end_date = dateFormat(departureDate, "YYYY-MM-DD")

        for (const item of demandSeasons) {
            const startDateValidation = isDateInRange(updatedDemandSeasons.start_date, item.start_date, item.end_date);
            if (startDateValidation) {
                showAlert(updatedDemandSeasons.start_date);
                console.log("Start Date Validation failed, not proceeding with API call");
                return;
            }

            const endDateValidation = isDateInRange(updatedDemandSeasons.end_date, item.start_date, item.end_date);
            if (endDateValidation) {
                showAlert(updatedDemandSeasons.end_date);
                console.log("End Date Validation failed, not proceeding with API call");
                return;
            }
        }

        const allSeasons = [...demandSeasons];
        allSeasons.push(updatedDemandSeasons);

        console.log("Final payload", allSeasons);

        setIsSaving(true);

        try {
            const response = await DataService.update({
                api: "rms/properties/group-quote-settings/" + app_state.property_id + "/",
                request: { method: 'POST', seasons: allSeasons }
            });
            if (response.status === "success") {
                console.log("Seasons saved successfully");
                getGroupQouteSettings().then((rs) => {
                    const data = deepCopy(rs.data);
                    dispatch({
                        type: UPDATE_STATE,
                        payload: {
                            app_state: {
                                groupIQSettings: data
                            }
                        }
                    });
                    setDemandSeasons(data.seasons);
                });
                setIsSaving(false);
                setIsChanged(false);
                setIsChangeRequest(false);
                setIsSaveEnabled(false);
                cancelNewDemandSeason();
            }
            else {
                console.log("Seasons not saved")
                setIsSaving(false);
                setIsChanged(false);
                setIsChangeRequest(false);
                setIsSaveEnabled(false);
            }
        }
        catch (err) {
            console.error('An error occurred', err);
            setIsSaving(false);
            setIsChanged(false);
            setIsChangeRequest(false);
            setIsSaveEnabled(false);
        }
    }

    // Create/Update Default Demand seasons POST API
    const saveDefaultDemandSeason = async () => {
        console.log("default Seasons payload", defaultDemandSeasons);
        setIsSaving(true);
        try {
            const response = await DataService.update({
                api: "rms/properties/group-quote-settings/" + app_state.property_id + "/",
                request: { method: 'POST', default_settings: defaultDemandSeasons }
            });
            if (response.status === "success") {
                console.log("Default Seasons saved successfully");
                getGroupQouteSettings().then((rs) => {
                    const data = deepCopy(rs.data);
                    dispatch({
                        type: UPDATE_STATE,
                        payload: {
                            app_state: {
                                groupIQSettings: data
                            }
                        }
                    });
                    //setDefaultDemandSeasons(data.default_settings);
                });
                setIsSaving(false);
                setIsChanged(false);
                setIsChangeRequest(false);
                setIsSaveEnabled(false);
                setExpandedIndexDefault(null);
                localStorage.setItem("isOpenDefault", false);
            }
            else {
                console.log("Default Seasons not saved")
                setIsSaving(false);
                setIsChanged(false);
                setIsChangeRequest(false);
                setIsSaveEnabled(false);
            }
        }
        catch (err) {
            console.error('An error occurred', err);
            setIsSaving(false);
            setIsChanged(false);
            setIsChangeRequest(false);
            setIsSaveEnabled(false);
        }
    }

    // Update existing Demand seasons POST API
    const saveDemandSeason = async () => {

        let validationFailed = false;

        for (const [index, item] of demandSeasons.entries()) {
            if (index === expandedIndex) {
                continue; // Skip the current expandedIndex
            }

            const startDateValidation = isDateInRange(demandSeasons[expandedIndex].start_date, item.start_date, item.end_date);

            if (startDateValidation) {
                showAlert(demandSeasons[expandedIndex].start_date);
                console.log("Start Date Validation failed, not proceeding with API call");
                validationFailed = true;
                break; // Stop further execution if startDateValidation fails
            }

            const endDateValidation = isDateInRange(demandSeasons[expandedIndex].end_date, item.start_date, item.end_date);

            if (endDateValidation) {
                showAlert(demandSeasons[expandedIndex].end_date);
                console.log("End Date Validation failed, not proceeding with API call");
                validationFailed = true;
                break; // Stop further execution if endDateValidation fails
            }
        }

        if (validationFailed) {
            return; // Exit the function if validation failed
        }

        console.log("Update Season payload", demandSeasons);

        setIsSaving(true);
        try {
            const response = await DataService.update({
                api: "rms/properties/group-quote-settings/" + app_state.property_id + "/",
                request: { method: 'POST', seasons: demandSeasons }
            });
            if (response.status === "success") {
                console.log("Seasons updated successfully");
                getGroupQouteSettings().then((rs) => {
                    const data = deepCopy(rs.data);
                    dispatch({
                        type: UPDATE_STATE,
                        payload: {
                            app_state: {
                                groupIQSettings: data
                            }
                        }
                    });
                    setDemandSeasons(data.seasons);
                });
                setIsSaving(false);
                setIsChanged(false);
                setIsChangeRequest(false);
                setIsSaveEnabled(false);
                setExpandedIndex(null);
            }
            else {
                console.log("Seasons not updated")
                setIsSaving(false);
                setIsChanged(false);
                setIsChangeRequest(false);
                setIsSaveEnabled(false);
            }
        }
        catch (err) {
            console.error('An error occurred', err);
            setIsSaving(false);
            setIsChanged(false);
            setIsChangeRequest(false);
            setIsSaveEnabled(false);
        }
    }

    // Delete existing demand season POST API
    const handleDelete = async (index) => {
        if (isChanged) {
            setIsShakeButton(true);
            setTimeout(function () {
                setIsShakeButton(false);
            }, 2000); // 3000 milliseconds = 3 seconds
            return;
        }
        const updatedDemandSeasons = [...demandSeasons];
        updatedDemandSeasons.splice(index, 1);
        setDemandSeasons(updatedDemandSeasons);

        console.log("delete payload", updatedDemandSeasons);

        try {
            const response = await DataService.update({
                api: "rms/properties/group-quote-settings/" + app_state.property_id + "/",
                request: { method: 'POST', seasons: updatedDemandSeasons }
            });
            if (response.status === "success") {
                console.log("Seasons deleted successfully");
                getGroupQouteSettings().then((rs) => {
                    const data = deepCopy(rs.data);
                    dispatch({
                        type: UPDATE_STATE,
                        payload: {
                            app_state: {
                                groupIQSettings: data
                            }
                        }
                    });
                });
            }
            else {
                console.log("Seasons not deleted")
            }
        }
        catch (err) {
            console.error('An error occurred', err);
        }
    };

    // Get groupIQ settings data
    const getGroupQouteSettings = async () => {
        let api = 'rms/properties/group-quote-settings/' + app_state.property_id + "/";
        const payload = { method: 'GET' };

        try {
            const response = await fetchDataSimple({ api, request: payload });
            if (response.status === "success") {
                localStorage.setItem("isGroupSettingsDashboard", false)
                localStorage.setItem("isGroupSettingsChanged", true)
                return response;
            }
            else {
                console.log("Error:", response.message);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const inputRef = useRef(null);
    // Handle clicks outside the input box
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (inputRef.current && !inputRef.current.contains(event.target)) {
                setEditModeDefault(false);  // Disable edit mode when clicking outside
                handleCloseDots();
            }
        };
        // Add event listener when editModeDefault is true
        if (editModeDefault) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        // Clean up the event listener on component unmount or when editModeDefault changes
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [editModeDefault]);

    const arrowStyle = {
        position: 'absolute',
        width: 0,
        height: 0,
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderBottom: '8px solid #fff', // Adjust color to match your Popover background
        top: -8,
        left: '50%',
        transform: 'translateX(-50%)',
    };

    let profitMarginElsDefault = Object.keys(defaultDemandSeasons?.profitMargins || {}).map((key, marginIndex) => {

        let curProfitMargin = defaultprofitMarginsTypes.find(i => i.name === key);
        let dotsBtn = '';

        if (!curProfitMargin) {
            curProfitMargin = { name: key, label: keyToLabel(key) };
            dotsBtn = (<>
                <span className="dots-btn" aria-describedby={idDots} variant="contained" onClick={handleClickDots}>...</span>
                <Popover
                    id={idDots}
                    open={openDots}
                    anchorEl={anchorElDots}
                    onClose={handleCloseDots}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    PaperProps={{
                        sx: {
                            position: 'absolute',
                            overflow: 'visible',
                            marginTop: '6px', marginLeft: '6px'
                        },
                    }}
                >
                    <Box className="profit-margin-dots-popup">
                        <Box sx={arrowStyle} />
                        <div className="rename" onClick={() => editProfitMarginDefault(marginIndex)}>Rename</div>
                        <div className="delete" onClick={() => deleteProfitMarginDefault(key)}>Delete</div>
                    </Box>
                </Popover>
            </>)
        }
        return (<div className="profit-margin-input-div" key={marginIndex} >
            {editModeDefault && editedMarginIndex === marginIndex ? (  // Check if the current index is being edited
                <TextField
                    ref={inputRef}
                    tabIndex={marginIndex}
                    className='editable-input-label' fullWidth size='small'
                    value={curProfitMargin.label}
                    onChange={(e) => renameProfitMarginDefault(marginIndex, e.target.value)}
                    autoFocus
                />
            ) : (
                <label className="profit-margin-input-label">
                    {curProfitMargin.label}
                    {dotsBtn}
                </label>
            )}
            <TextField
                // tabIndex={marginIndex}
                className='text-field'
                fullWidth size='small'
                placeholder={curProfitMargin.label}
                value={defaultDemandSeasons.profitMargins[key] === "" ? "" : convertToPercent(defaultDemandSeasons.profitMargins[key])}
                onChange={(event) => handleDefaultInputChange(curProfitMargin.name, true, event)}
                InputProps={{
                    endAdornment: (
                        <div className="input-adornment"> % </div>
                    ),
                }}
            />
        </div>)
    })

    let newProfitMarginElsDefault = Object.keys(newDemandSeasons.profitMargins).map((key, marginIndex) => {
        let curProfitMargin = defaultprofitMarginsTypes.find(i => i.name === key);
        let dotsBtn = '';

        if (!curProfitMargin) {
            curProfitMargin = { name: key, label: keyToLabel(key) };
            dotsBtn = (<>
                <span className="dots-btn" aria-describedby={idDots} variant="contained" onClick={handleClickDots}>...</span>
                <Popover
                    id={idDots}
                    open={openDots}
                    anchorEl={anchorElDots}
                    onClose={handleCloseDots}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    PaperProps={{
                        sx: {
                            position: 'absolute',
                            overflow: 'visible',
                            marginTop: '6px', marginLeft: '6px'
                        },
                    }}
                >
                    <Box className="profit-margin-dots-popup">
                        <Box sx={arrowStyle} />
                        <div className="rename" onClick={() => editProfitMarginNew(marginIndex)}>Rename</div>
                        <div className="delete" onClick={() => deleteProfitMarginNew(key)}>Delete</div>
                    </Box>
                </Popover>
            </>)
        }
        return (<div className="profit-margin-input-div" key={marginIndex} >
            {editModeDefault && editedMarginIndex === marginIndex ? (  // Check if the current index is being edited
                <TextField
                    ref={inputRef}
                    tabIndex={marginIndex}
                    className='editable-input-label' fullWidth size='small'
                    value={curProfitMargin.label}
                    onChange={(e) => renameProfitMarginNew(marginIndex, e.target.value)}
                    autoFocus
                />
            ) : (
                <label className="profit-margin-input-label">
                    {curProfitMargin.label}
                    {dotsBtn}
                </label>
            )}
            <TextField
                // tabIndex={marginIndex}
                className='text-field'
                fullWidth size='small'
                placeholder={curProfitMargin.label}
                value={newDemandSeasons.profitMargins[key] === "" ? "" : convertToPercent(newDemandSeasons.profitMargins[key])}
                onChange={(event) => handleNewSeasonInputChange(curProfitMargin.name, true, event)}
                InputProps={{
                    endAdornment: (
                        <div className="input-adornment"> % </div>
                    ),
                }}
            />
        </div>)
    })

    // Change existing seasons date range 
    const handleChangeSeasonDate = (index, item, start, end) => {
        setIsChanged(true);
        setIsChangeRequest(true);
        const updatedDemandSeasons = [...demandSeasons];
        updatedDemandSeasons[index].start_date = dateFormat(start, "YYYY-MM-DD");
        updatedDemandSeasons[index].end_date = dateFormat(end, "YYYY-MM-DD");

        console.log("updatedDemandSeasons", updatedDemandSeasons)
        setDemandSeasons(updatedDemandSeasons);

        //Empty field validation
        const hasEmptyField = emptyValueValidation(updatedDemandSeasons[index]);
        setIsSaveEnabled(hasEmptyField);
    }

    // Change new seasons date range 
    const handleChangeSeasonDateNew = (start, end) => {
        setArrivalDateTemp(start);
        setDepartureDateTemp(end);
    }

    // Input change for default season
    const handleDefaultInputChange = (field, isProfitMargin, event) => {
        const value = event.target.value;
        const newValue = Number(value);
        if (isNaN(newValue)) {
            return;
        }

        if (field !== 'complimentary_rooms' && field !== 'per_paid_rooms') {
            if (newValue > 100) {
                return;
            }
        }

        setIsChanged(true);
        setIsChangeRequest(true);

        const updatedDemandSeasons = { ...defaultDemandSeasons };

        if (isProfitMargin) {
            updatedDemandSeasons.profitMargins[field] = convertToPercent(newValue, 'int');
        }
        else {
            updatedDemandSeasons[field] = field === 'commission_percentage' ? convertToPercent(newValue, 'int') : newValue;
        }

        setDefaultDemandSeasons(updatedDemandSeasons);

        //Empty field validation
        const hasEmptyField = emptyValueValidation(updatedDemandSeasons);
        setIsSaveEnabled(hasEmptyField);
    };

    // Input change for new season
    const handleNewSeasonInputChange = (field, isProfitMargin, event) => {
        const value = event.target.value;
        const newValue = Number(value);
        if (isNaN(newValue)) {
            return;
        }

        if (field !== 'complimentary_rooms' && field !== 'per_paid_rooms') {
            if (newValue > 100) {
                return;
            }
        }

        setIsChanged(true);
        setIsChangeRequest(true);

        const updatedDemandSeasons = { ...newDemandSeasons };

        if (isProfitMargin) {
            updatedDemandSeasons.profitMargins[field] = convertToPercent(newValue, 'int');
        }
        else {
            updatedDemandSeasons[field] = field === 'commission_percentage' ? convertToPercent(newValue, 'int') : newValue;
        }

        setNewDemandSeasons(updatedDemandSeasons);

        //Empty field validation
        const hasEmptyField = emptyValueValidation(updatedDemandSeasons);
        setIsSaveEnabled(hasEmptyField);
    };

    // Input change for existing season
    const handleSeasonInputChange = (index, field, isProfitMargin, event) => {
        const value = event.target.value;
        const newValue = Number(value);
        if (isNaN(newValue)) {
            return;
        }

        if (field !== 'complimentary_rooms' && field !== 'per_paid_rooms') {
            if (newValue > 100) {
                return;
            }
        }

        setIsChanged(true);
        setIsChangeRequest(true);

        const updatedDemandSeasons = [...demandSeasons];

        if (isProfitMargin) {
            updatedDemandSeasons[index].profitMargins[field] = convertToPercent(newValue, 'int');
        }
        else {
            updatedDemandSeasons[index][field] = field === 'commission_percentage' ? convertToPercent(newValue, 'int') : newValue;
        }
        setDemandSeasons(updatedDemandSeasons);

        //Empty field validation
        const hasEmptyField = emptyValueValidation(updatedDemandSeasons[index]);
        setIsSaveEnabled(hasEmptyField);
    };

    const emptyValueValidation = (obj) => {
        const hasEmptyField = Object.values(obj).some(val =>
            typeof val === 'object'
                ? Object.values(val).some(subVal => subVal === '' || subVal === "")
                : val === '' || val === ""
        );

        if (hasEmptyField) {
            return false;
        }
        else {
            return true;
        }
    }

    return (
        <Box className='tab-content-root'>

            {/* Default Season */}
            <Paper className="demand-seasons-accordion" elevation={3}
                style={{ padding: '10px', marginBottom: '10px', cursor: expandedIndexDefault === 0 ? 'default' : 'pointer' }}
                onClick={() => expandedIndexDefault === 0 ? null : handleToggleDefault(0)}
            >
                <div
                    onClick={() => expandedIndexDefault !== 0 ? null : handleToggleDefault(0)}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
                >

                    <div className="default-setting-text">Default</div>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', gap: "12px" }}>
                        <svg style={{ transform: expandedIndexDefault === 0 ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease-in-out' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#606060" viewBox="0 0 256 256">
                            <path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"></path>
                        </svg>
                    </div>
                </div>

                <Collapse in={expandedIndexDefault === 0}>
                    <Typography style={{ marginTop: '10px' }}>

                        <Box className="block-heading">
                            <div>Complimentary Stay</div>
                            <div className="divider"></div>
                        </Box>

                        <Box item sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", alignItems: "center", gap: 2, width: "100%" }}>
                            <div>
                                <label>Complimentary Rooms</label>
                                <TextField
                                    tabIndex={1}
                                    className='text-field'
                                    fullWidth size='small'
                                    placeholder='Complimentary Rooms'
                                    value={defaultDemandSeasons.complimentary_rooms}
                                    onChange={(event) => handleDefaultInputChange('complimentary_rooms', false, event)}
                                    autoFocus
                                />
                            </div>
                            <div>
                                <label>Per Paid Rooms</label>
                                <TextField
                                    tabIndex={1}
                                    className='text-field'
                                    fullWidth size='small'
                                    placeholder='Per Paid Rooms'
                                    value={defaultDemandSeasons.per_paid_rooms}
                                    onChange={(event) => handleDefaultInputChange('per_paid_rooms', false, event)}
                                />
                            </div>
                        </Box>

                        <Box className="block-heading">
                            <div>Commission %</div>
                            <div className="divider"></div>
                        </Box>

                        <Box item>
                            <TextField
                                tabIndex={1}
                                className='text-field'
                                fullWidth size='small'
                                placeholder='Commission'
                                value={defaultDemandSeasons.commission_percentage === "" ? "" : convertToPercent(defaultDemandSeasons.commission_percentage)}
                                onChange={(event) => handleDefaultInputChange('commission_percentage', false, event)}
                                InputProps={{
                                    endAdornment: (
                                        <div className="input-adornment" style={{ width: "32px" }}> % </div>
                                    ),
                                }}
                            />
                        </Box>

                        <Box className="block-heading">
                            <div>Profit Margins</div>
                            <div className="divider"></div>
                        </Box>

                        <Box className="pofit-margin-inputs" item>

                            {profitMarginElsDefault}

                            <div>
                                <label></label>
                                <Button
                                    className="profit-margin-add-btn"
                                    onClick={(e) => {
                                        addDefaultProfitMarginInput()
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#606060" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"></path></svg>
                                </Button>
                            </div>

                        </Box>

                        <Box className={isShakeButton ? "create-demand-action-btns bt-shake" : "create-demand-action-btns"}>
                            <Button
                                disabled={!isChanged}
                                onClick={discardChangesDefault}
                                variant="outlined"
                                className="navigate-cancel-button btn-active"
                                size="small"
                                sx={{ minWidth: "auto", lineHeight: "unset" }}
                                style={isSaving ? { pointerEvents: "none" } : {}}
                            >
                                Discard Changes
                            </Button>
                            {isSaving ?
                                <Button
                                    disabled
                                    variant="outlined"
                                    size="small"
                                    className="navigate-save-button btn-active"
                                    sx={{ minWidth: "auto", lineHeight: "unset", gap: 1, pointerEvents: "none", width: "71.58px", height: "30.2px" }}
                                >
                                    <CircularProgress color="inherit" size={16} />
                                </Button>
                                :
                                usrReadyOnlyStatus ?
                                    <Tooltip title={getPermissionMessage(userLoginType)} arrow followCursor>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            className="navigate-save-button"
                                            sx={{ minWidth: "auto", lineHeight: "unset" }}
                                            style={isSaving ? { pointerEvents: "none" } : {}}
                                        > Save </Button></Tooltip> : <Button
                                            disabled={!isSaveEnabled}
                                            onClick={() => {
                                                saveDefaultDemandSeason();
                                            }}
                                            variant="outlined"
                                            size="small"
                                            className="navigate-save-button btn-active"
                                            sx={{ minWidth: "auto", lineHeight: "unset" }}
                                            style={isSaving ? { pointerEvents: "none" } : {}}
                                        >
                                        Save
                                    </Button>
                            }
                        </Box>

                    </Typography>
                </Collapse>
            </Paper>

            {/* Demand Seasons List */}
            {demandSeasons.map((item, index) => {
                let profitMarginEls = Object.keys(item.profitMargins).map((key, marginIndex) => {
                    let curProfitMargin = defaultprofitMarginsTypes.find(i => i.name === key);
                    let dotsBtn = '';
                    if (!curProfitMargin) {
                        curProfitMargin = { name: key, label: keyToLabel(key) };
                        dotsBtn = (<>
                            <span className="dots-btn" aria-describedby={idDots} variant="contained" onClick={handleClickDots}>...</span>
                            <Popover
                                id={idDots}
                                open={openDots}
                                anchorEl={anchorElDots}
                                onClose={handleCloseDots}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                                PaperProps={{
                                    sx: {
                                        position: 'absolute',
                                        overflow: 'visible',
                                        marginTop: '6px', marginLeft: '6px'
                                    },
                                }}
                            >
                                <Box className="profit-margin-dots-popup">
                                    <Box sx={arrowStyle} />
                                    <div className="rename" onClick={() => editProfitMargin(index, marginIndex)}>Rename</div>
                                    <div className="delete" onClick={() => deleteProfitMargin(index, key)}>Delete</div>
                                </Box>
                            </Popover>
                        </>)
                    }
                    return (<div className="profit-margin-input-div" key={marginIndex} >
                        {editModeDefault && editedMarginIndex === marginIndex ? (  // Check if the current index is being edited
                            <TextField
                                ref={inputRef}
                                tabIndex={marginIndex}
                                className='editable-input-label' fullWidth size='small'
                                value={curProfitMargin.label}
                                onChange={(e) => renameProfitMargin(index, marginIndex, e.target.value)}
                                autoFocus
                            />
                        ) : (
                            <label className="profit-margin-input-label">
                                {curProfitMargin.label}
                                {dotsBtn}
                            </label>
                        )}
                        <TextField
                            // tabIndex={marginIndex}
                            className='text-field'
                            fullWidth size='small'
                            placeholder={curProfitMargin.label}
                            value={convertToPercent(item.profitMargins[key])}
                            onChange={(event) => handleSeasonInputChange(index, curProfitMargin.name, true, event)}
                            InputProps={{
                                endAdornment: (
                                    <div className="input-adornment"> % </div>
                                ),
                            }}
                        />
                    </div>)
                })
                return (
                    <Paper className="demand-seasons-accordion" key={index} elevation={3}
                        style={{ padding: '10px', marginBottom: '10px', cursor: expandedIndex === index ? 'default' : 'pointer' }}
                        onClick={() => expandedIndex === index ? null : handleToggle(index)}
                    >
                        <div
                            onClick={() => expandedIndex !== index ? null : handleToggle(index)}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
                        >

                            <div>{dateFormat(item.start_date, "MMM DD, YYYY") + " - " + dateFormat(item.end_date, "MMM DD, YYYY")}</div>

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', gap: "12px" }}>
                                {!usrReadyOnlyStatus && (<Tooltip title="Delete" arrow >
                                    <div className="card-svg">
                                        <svg className={expandedIndex === index ? "seasons-delete-icon show" : "seasons-delete-icon"} onClick={() => handleDelete(index)} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#E03131" viewBox="0 0 256 256">
                                            <path d="M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"></path>
                                        </svg>
                                    </div>
                                </Tooltip>)}
                                <svg style={{ transform: expandedIndex === index ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease-in-out' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#606060" viewBox="0 0 256 256">
                                    <path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"></path>
                                </svg>
                            </div>
                        </div>

                        <Collapse in={expandedIndex === index}>
                            <Typography style={{ marginTop: '10px' }}>
                                <Box className="date-range-picker-block">
                                    <Box item>
                                        <div className='top-bar-item'>
                                            <label>Select Date Range</label>
                                            <TextField
                                                tabIndex={1}
                                                onKeyDown={preventTyping}
                                                onClick={toggleDateRangePickerVisiblity}
                                                style={{ cursor: "pointer" }}
                                                fullWidth
                                                className="text-field vijay"
                                                size="small"
                                                value={dateFormat(item.start_date, "MMM DD YYYY") + " - " + dateFormat(item.end_date, "MMM DD YYYY")}
                                                InputProps={{
                                                    endAdornment: (
                                                        <IconButton onClick={toggleDateRangePickerVisiblity} edge="end">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#00415F" viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-96-88v64a8,8,0,0,1-16,0V132.94l-4.42,2.22a8,8,0,0,1-7.16-14.32l16-8A8,8,0,0,1,112,120Zm59.16,30.45L152,176h16a8,8,0,0,1,0,16H136a8,8,0,0,1-6.4-12.8l28.78-38.37A8,8,0,1,0,145.07,132a8,8,0,1,1-13.85-8A24,24,0,0,1,176,136,23.76,23.76,0,0,1,171.16,150.45Z"></path></svg>
                                                        </IconButton>
                                                    ),
                                                }}
                                            />
                                        </div>
                                    </Box>
                                    <Box item
                                        className={dateRangePickerVisiblity ? "date-range-picker-container" : "date-range-picker-container-false"}
                                        style={{ top: "unset", right: '1rem' }}
                                    >
                                        <div className='top-bar-item'>
                                            <DateRangePicker
                                                showSelectionPreview={true}
                                                moveRangeOnFirstSelection={false}
                                                months={2}
                                                direction="horizontal"
                                                ranges={[
                                                    {
                                                        startDate: new Date(item.start_date),
                                                        endDate: new Date(item.end_date),
                                                        key: 'selection',
                                                    },
                                                ]}
                                                minDate={new Date()} // disabled previous date from current date
                                                onChange={(ranges) => {
                                                    handleChangeSeasonDate(index, item, ranges.selection.startDate, ranges.selection.endDate);
                                                }}
                                            />
                                            <Box sx={{ background: "#FFF" }} className="datepicker-done-btn"><Button onClick={toggleDateRangePickerVisiblity}>Done</Button></Box>
                                        </div>
                                    </Box>
                                </Box>

                                <Box className="block-heading">
                                    <div>Complimentary Stay</div>
                                    <div className="divider"></div>
                                </Box>

                                <Box item sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", alignItems: "center", gap: 2, width: "100%" }}>
                                    <div>
                                        <label>Complimentary Rooms</label>
                                        <TextField
                                            tabIndex={1}
                                            className='text-field'
                                            fullWidth size='small'
                                            placeholder='Complimentary Rooms'
                                            value={item.complimentary_rooms}
                                            onChange={(event) => handleSeasonInputChange(index, 'complimentary_rooms', false, event)}
                                        />
                                    </div>
                                    <div>
                                        <label>Per Paid Rooms</label>
                                        <TextField
                                            tabIndex={1}
                                            className='text-field'
                                            fullWidth size='small'
                                            placeholder='Per Paid Rooms'
                                            value={item.per_paid_rooms}
                                            onChange={(event) => handleSeasonInputChange(index, 'per_paid_rooms', false, event)}
                                        />
                                    </div>
                                </Box>

                                <Box className="block-heading">
                                    <div>Commission %</div>
                                    <div className="divider"></div>
                                </Box>

                                <Box item>
                                    <TextField
                                        tabIndex={1}
                                        className='text-field'
                                        fullWidth size='small'
                                        placeholder='Commission %'
                                        value={convertToPercent(item.commission_percentage)}
                                        onChange={(event) => handleSeasonInputChange(index, 'commission_percentage', false, event)}
                                        InputProps={{
                                            endAdornment: (
                                                <div className="input-adornment" style={{ width: "32px" }}> % </div>
                                            ),
                                        }}
                                    />
                                </Box>

                                <Box className="block-heading">
                                    <div>Profit Margins</div>
                                    <div className="divider"></div>
                                </Box>

                                <Box className="pofit-margin-inputs" item>

                                    {profitMarginEls}

                                    <div>
                                        <label></label>
                                        <Button
                                            className="profit-margin-add-btn"
                                            onClick={(e) => {
                                                addProfitMarginInput(index)
                                            }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#606060" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"></path></svg>
                                        </Button>
                                    </div>
                                </Box>

                                <Box className={isShakeButton ? "create-demand-action-btns bt-shake" : "create-demand-action-btns"}>
                                    <Button
                                        disabled={!isChanged}
                                        onClick={discardChanges}
                                        variant="outlined"
                                        className="navigate-cancel-button btn-active"
                                        size="small"
                                        sx={{ minWidth: "auto", lineHeight: "unset" }}
                                        style={isSaving ? { pointerEvents: "none" } : {}}
                                    >
                                        Discard Changes
                                    </Button>
                                    {isSaving ?
                                        <Button
                                            disabled
                                            variant="outlined"
                                            size="small"
                                            className="navigate-save-button btn-active"
                                            sx={{ minWidth: "auto", lineHeight: "unset", gap: 1, pointerEvents: "none", width: "71.58px", height: "30.2px" }}
                                        >
                                            <CircularProgress color="inherit" size={16} />
                                        </Button>
                                        :
                                        usrReadyOnlyStatus ?
                                            <Tooltip title={getPermissionMessage(userLoginType)} arrow followCursor>
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    className="navigate-save-button"
                                                    sx={{ minWidth: "auto", lineHeight: "unset" }}
                                                    style={isSaving ? { pointerEvents: "none" } : {}}
                                                > Save </Button></Tooltip> : <Button
                                                    disabled={!isSaveEnabled}
                                                    onClick={() => {
                                                        saveDemandSeason();
                                                    }}
                                                    variant="outlined"
                                                    size="small"
                                                    className="navigate-save-button btn-active"
                                                    sx={{ minWidth: "auto", lineHeight: "unset" }}
                                                    style={isSaving ? { pointerEvents: "none" } : {}}
                                                >
                                                Save
                                            </Button>
                                    }
                                </Box>

                            </Typography>
                        </Collapse>
                    </Paper>
                );
            })}

            {/* Add New Season */}
            {!showAddDemandSeason ? null :
                <Box className="demand-seasons-accordion">
                    <Typography>
                        <Box className="date-range-picker-block">
                            <Box item>
                                <div className='top-bar-item'>
                                    <label>Select Date Range</label>
                                    <TextField
                                        tabIndex={1}
                                        onKeyDown={preventTyping}
                                        onClick={toggleDateRangePickerVisiblity}
                                        style={{ cursor: "pointer" }}
                                        fullWidth
                                        className="text-field vijay"
                                        size="small"
                                        value={dateFormat(arrivalDate, "ddd, MMM DD YYYY") + " - " + dateFormat(departureDate, "ddd, MMM DD YYYY")}
                                        InputProps={{
                                            endAdornment: (
                                                <IconButton onClick={toggleDateRangePickerVisiblity} edge="end">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#00415F" viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-96-88v64a8,8,0,0,1-16,0V132.94l-4.42,2.22a8,8,0,0,1-7.16-14.32l16-8A8,8,0,0,1,112,120Zm59.16,30.45L152,176h16a8,8,0,0,1,0,16H136a8,8,0,0,1-6.4-12.8l28.78-38.37A8,8,0,1,0,145.07,132a8,8,0,1,1-13.85-8A24,24,0,0,1,176,136,23.76,23.76,0,0,1,171.16,150.45Z"></path></svg>
                                                </IconButton>
                                            ),
                                        }}
                                    />
                                </div>
                            </Box>
                            <Box item
                                className={dateRangePickerVisiblity ? "date-range-picker-container" : "date-range-picker-container-false"}
                                style={{ top: "unset", right: '1rem' }}
                            >
                                <div className='top-bar-item'>
                                    <DateRangePicker
                                        showSelectionPreview={true}
                                        moveRangeOnFirstSelection={false}
                                        months={2}
                                        direction="horizontal"
                                        ranges={[
                                            {
                                                startDate: new Date(arrivalDateTemp),
                                                endDate: new Date(departureDateTemp),
                                                key: 'selection',
                                            },
                                        ]}
                                        minDate={new Date()} // disabled previous date from current date
                                        onChange={(ranges) => {
                                            handleChangeSeasonDateNew(ranges.selection.startDate, ranges.selection.endDate);
                                        }}
                                    />
                                    <Box sx={{ background: "#FFF" }} className="datepicker-done-btn"><Button onClick={toggleDateRangePickerVisiblity}>Done</Button></Box>
                                </div>
                            </Box>
                        </Box>

                        <Box className="block-heading">
                            <div>Complimentary Stay</div>
                            <div className="divider"></div>
                        </Box>


                        <Box item sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", alignItems: "center", gap: 2, width: "100%" }}>
                            <div>
                                <label>Complimentary Rooms</label>
                                <TextField
                                    tabIndex={1}
                                    className='text-field'
                                    fullWidth size='small'
                                    placeholder='Complimentary Rooms'
                                    value={newDemandSeasons.complimentary_rooms}
                                    onChange={(event) => handleNewSeasonInputChange('complimentary_rooms', false, event)}
                                />
                            </div>
                            <div>
                                <label style={{ fontFamily: "SFUI Medium", color: "#606060", fontWeight: "unset", fontSize: "12px" }}>Per Paid Rooms</label>
                                <TextField
                                    tabIndex={1}
                                    className='text-field'
                                    fullWidth size='small'
                                    placeholder='Per Paid Rooms'
                                    value={newDemandSeasons.per_paid_rooms}
                                    onChange={(event) => handleNewSeasonInputChange('per_paid_rooms', false, event)}
                                />
                            </div>
                        </Box>

                        <Box className="block-heading">
                            <div>Commission %</div>
                            <div className="divider"></div>
                        </Box>

                        <Box item>
                            <TextField
                                tabIndex={1}
                                className='text-field'
                                fullWidth size='small'
                                placeholder='Commission %'
                                value={newDemandSeasons.commission_percentage === "" ? "" : convertToPercent(newDemandSeasons.commission_percentage)}
                                onChange={(event) => handleNewSeasonInputChange('commission_percentage', false, event)}
                                InputProps={{
                                    endAdornment: (
                                        <div className="input-adornment" style={{ width: "32px" }}> % </div>
                                    ),
                                }}
                            />
                        </Box>

                        <Box className="block-heading">
                            <div>Profit Margins</div>
                            <div className="divider"></div>
                        </Box>

                        <Box className="pofit-margin-inputs" item>

                            {newProfitMarginElsDefault}

                            <div>
                                <label></label>
                                <Button
                                    className="profit-margin-add-btn"
                                    onClick={(e) => {
                                        addNewProfitMarginInput()
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#606060" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"></path></svg>
                                </Button>
                            </div>
                        </Box>

                        <Box className={isShakeButton ? "create-demand-action-btns bt-shake" : "create-demand-action-btns"}>
                            <Button
                                //disabled={!isChanged}
                                onClick={cancelNewDemandSeason}
                                variant="outlined"
                                className="navigate-cancel-button btn-active"
                                size="small"
                                sx={{ minWidth: "auto", lineHeight: "unset" }}
                                style={isSaving ? { pointerEvents: "none" } : {}}
                            >
                                cancel
                            </Button>
                            {isSaving ?
                                <Button
                                    disabled
                                    variant="outlined"
                                    size="small"
                                    className="navigate-save-button btn-active"
                                    sx={{ minWidth: "auto", lineHeight: "unset", gap: 1, pointerEvents: "none", width: "84.05px", height: "30.2px" }}
                                >
                                    <CircularProgress color="inherit" size={16} />
                                </Button>
                                :
                                <Button
                                    disabled={!isSaveEnabled}
                                    onClick={() => {
                                        createDemandSeason();
                                    }}
                                    variant="outlined"
                                    size="small"
                                    className="navigate-save-button btn-active"
                                    sx={{ minWidth: "auto", lineHeight: "unset" }}
                                    style={isSaving ? { pointerEvents: "none" } : {}}
                                >
                                    Create
                                </Button>
                            }
                        </Box>

                    </Typography>
                </Box>
            }

            <Alert
                severity="error"
                className="save-changes-alert-settings display-none"
                sx={{ position: "absolute", bottom: "14px", left: "16px", padding: "0px 12px" }}
            >
                {alertText}
            </Alert>

            {addButtonHidden || isChanged || usrReadyOnlyStatus ? null :
                <Button
                    variant="outlined"
                    className="add-button"
                    size="small"
                    sx={{ lineHeight: "auto" }}
                    onClick={() => {
                        addNewDemandSeason();
                    }}
                >
                    <span className="add-btn-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#333333" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"></path></svg>
                    </span>
                    <span className="add-btn-txt">Add Demand Season</span>
                </Button>
            }
        </Box>
    );
}

function BlackoutDates(props, openDefault) {
    const dispatch = useDispatch();
    const blankRestriction = { cta: false, ctd: false, close: false, min_los: null, max_los: null, };
    const { auth } = useSelector(appState => appState);
    const { app_state } = useSelector((state) => state.app.current_state);
    const { groupIQSettings } = app_state;
    const userLoginType = useUserLoginType();
    const usrReadyOnlyStatus = userReadyOnlyStatus(userLoginType);

    if (groupIQSettings.blackout_dates == undefined) {
        groupIQSettings.blackout_dates = [];
    }
    const [currentSelectedDates, setCurrentSelectedDates] = useState(groupIQSettings.blackout_dates);
    const [currentSelectedDatesBackup, setCurrentSelectedDatesBackup] = useState(groupIQSettings.blackout_dates);

    const [compState, setcompState] = useState({
        restrictionOpen: true,
        entryFields: [], entry: { ...blankRestriction }, progress: "loaded", saveReady: false,
        modified: false
    });

    const [isChangeRequest, setIsChangeRequest] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    localStorage.setItem('isChanged', isChangeRequest);

    const selectedCalendarDates = useRef([]);
    const [modifiedCalendarDates, setModifiedCalendarDates] = useState([])
    const property_info = getPropertyInfo(auth.profile.property_details, app_state.property_id);
    const [dateRange, setDateRange] = useState({ date_from: app_state.as_of_date, date_until: moment(app_state.as_of_date).add(89, "days").format("YYYY-MM-DD") });
    const [formattedRanges, setFormattedRanges] = useState([]);
    const [formattedRangesOld, setFormattedRangesOld] = useState([]);

    useEffect(() => {
        setFormattedRangesOld(currentSelectedDates.map(date => ({ date, active: true })));
    }, [groupIQSettings]);

    const modifyCalendarDates = (calendarDates) => {
        selectedCalendarDates.current = [...calendarDates.filter(i => i.active)]

        selectedCalendarDates.current.forEach((item) => {
            if (currentSelectedDates.includes(item.date)) {
                item.active = false;
                showAlert(item.date);
            }
        });

        const updatedSelectedCalendarDates = selectedCalendarDates.current.filter(i => i.active);

        if (updatedSelectedCalendarDates.length > 0) {
            setcompState(state => {
                return { ...state, saveReady: true }
            })
            setFormattedRanges(updatedSelectedCalendarDates);
            setIsChangeRequest(true);
        }

    }

    const handleDeleteBlackoutDate = (index, item) => {
        const formattedRangesCopy = [...formattedRanges]
        formattedRangesCopy.splice(index, 1);

        setFormattedRanges(formattedRangesCopy);

        setModifiedCalendarDates(prev => {
            return formattedRangesCopy;
        })
        setcompState(state => {
            return { ...state, saveReady: true }
        })

        setIsChangeRequest(true);
    }

    const handleDeleteBlackoutDateOld = (index, item) => {
        const formattedRangesOldCopy = [...formattedRangesOld]
        formattedRangesOldCopy.splice(index, 1);

        setFormattedRangesOld(formattedRangesOldCopy);

        const currentSelectedDatesCopy = []
        formattedRangesOldCopy.forEach((item) => {
            currentSelectedDatesCopy.push(item.date);
        });
        setCurrentSelectedDates(currentSelectedDatesCopy);

        setIsChangeRequest(true);
    }

    const saveBlackoutDates = async () => {
        const payload = [];

        formattedRangesOld.forEach((range) => {
            payload.push(dateFormat(range.date, "YYYY-MM-DD"));
        });

        formattedRanges.forEach((range) => {
            payload.push(dateFormat(range.date, "YYYY-MM-DD"));
        });

        console.log("payload", payload)

        setIsSaving(true);

        try {
            const response = await DataService.update({
                api: "rms/properties/group-quote-settings/" + app_state.property_id + "/",
                request: { method: 'POST', blackout_dates: payload }
            });
            if (response.status === "success") {
                console.log("Blackout Dates saved successfully");
                getGroupQouteSettings().then((rs) => {
                    const data = deepCopy(rs.data);
                    dispatch({
                        type: UPDATE_STATE,
                        payload: {
                            app_state: {
                                groupIQSettings: data
                            }
                        }
                    });
                    setCurrentSelectedDates(data.blackout_dates);
                    setCurrentSelectedDatesBackup(data.blackout_dates);
                    setFormattedRangesOld(data.blackout_dates.map(date => ({ date, active: true })));
                    setFormattedRanges([]);
                    setModifiedCalendarDates(prev => {
                        return [];
                    })
                    setcompState(state => {
                        return { ...state, saveReady: true }
                    })
                });
                setIsSaving(false);
                setIsChangeRequest(false);
            }
            else {
                console.log("Blackout Dates not saved")
                setIsSaving(false);
                setIsChangeRequest(false);
            }
        }
        catch (err) {
            console.error('An error occurred', err);
            setIsSaving(false);
            setIsChangeRequest(false);
        }
    }

    const cancelBlackoutDates = (dates) => {
        setFormattedRangesOld(currentSelectedDatesBackup.map(date => ({ date, active: true })));
        setFormattedRanges([]);
        setModifiedCalendarDates(prev => {
            return [];
        })
        setcompState(state => {
            return { ...state, saveReady: true }
        })
        setCurrentSelectedDates(currentSelectedDatesBackup);
        setIsChangeRequest(false);
    }

    // Get groupIQ settings data
    const getGroupQouteSettings = async () => {
        let api = 'rms/properties/group-quote-settings/' + app_state.property_id + "/";
        const payload = { method: 'GET' };

        try {
            const response = await fetchDataSimple({ api, request: payload });
            if (response.status === "success") {
                localStorage.setItem("isGroupSettingsDashboard", false)
                localStorage.setItem("isGroupSettingsChanged", true)
                return response;
            }
            else {
                console.log("Error:", response.message);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const [alertText, setAlertText] = useState("");
    const showAlert = async (date) => {
        setAlertText(dateFormat(date, "DD MMM, YY") + " is already present");
        let alertContainer = document.getElementsByClassName("save-changes-alert-settings");
        if (alertContainer.length > 0) {
            alertContainer[0].className = alertContainer[0].className.replace("display-none", "").trim();
            setTimeout(() => {
                alertContainer[0].className += " display-none";
            }, 2000);
        }
    }

    return (
        <Box className='tab-content-root'>
            <Box sx={{ display: "grid", gridTemplateColumns: "290px auto", gap: "8px" }}>
                <Box component="section">
                    <GroupCustomCalendar asOfDate={app_state.as_of_date}
                        changeDateRange={(dateRange) => {
                            setDateRange(prev => dateRange)
                        }}
                        weekdaysSelection={"disabled"}
                        rangeInput={"disabled"}
                        selectedDates={modifiedCalendarDates}
                        modifyCalendarDates={modifyCalendarDates}
                    />
                </Box>
                <Box className="calendar-dates-container" p={0}>
                    {formattedRanges.length === 0 && formattedRangesOld.length === 0 ?
                        <div className="no-blackout-dates">
                            <svg width="51" height="56" viewBox="0 0 51 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_297_848)">
                                    <path d="M2.56543 38.5599V12.2299C2.56543 9.69989 4.61543 7.63989 7.15543 7.63989H48.4354V36.1099C48.4354 37.3299 47.9554 38.4899 47.0954 39.3499L34.2854 52.1599C33.4254 53.0199 32.2554 53.4999 31.0454 53.4999H2.56543V38.5499V38.5599Z" stroke="#67C8F5" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M17.5156 2.48999V12.8" stroke="#67C8F5" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M34.5156 2.48999V12.8" stroke="#67C8F5" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M13.075 17.67L9.08496 21.66" stroke="#FFC9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9.08496 17.67L13.075 21.66" stroke="#FFC9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M24.2459 17.67L20.2559 21.66" stroke="#FFC9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.2559 17.67L24.2459 21.66" stroke="#FFC9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M13.075 29.12L9.08496 33.11" stroke="#FFC9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9.08496 29.12L13.075 33.11" stroke="#FFC9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M24.2459 29.12L20.2559 33.11" stroke="#FFC9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.2559 29.12L24.2459 33.11" stroke="#FFC9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M35.405 17.67L31.415 21.66" stroke="#FFC9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M31.415 17.67L35.405 21.66" stroke="#FFC9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M47.2955 39.15L34.0755 52.37C33.6555 52.79 32.9355 52.49 32.9355 51.9V41.27C32.9355 39.47 34.3955 38.02 36.1855 38.02H46.8155C47.4155 38.02 47.7055 38.74 47.2855 39.16L47.2955 39.15Z" stroke="#67C8F5" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_297_848">
                                        <rect width="49.87" height="55.02" fill="white" transform="translate(0.56543 0.48999)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <div className="err-msg"> No Blackout Dates Applied</div>
                        </div>
                        :
                        <div className="blackout-dates-heading">Current Blackout Dates</div>
                    }

                    <Box className='dates-container' p={1}>
                        {formattedRangesOld.map((range, index) => (
                            <Chip
                                size="small"
                                key={index}
                                label={dateFormat(range.date, "DD MMM, YY")}
                                variant="filled"
                                onDelete={() => handleDeleteBlackoutDateOld(index, range)}
                            />
                        ))}
                        {formattedRanges.map((range, index) => (
                            <Chip
                                size="small"
                                key={index}
                                label={dateFormat(range.date, "DD MMM, YY")}
                                variant="filled"
                                onDelete={() => handleDeleteBlackoutDate(index, range)}
                            />
                        ))}
                    </Box>
                </Box>
            </Box>

            <Alert
                severity="error"
                className="save-changes-alert-settings display-none"
                sx={{ position: "absolute", bottom: "14px", left: "16px", padding: "0px 12px" }}
            >
                {alertText}
            </Alert>

            <Box className="create-demand-action-btns" sx={{ display: "flex", justifyContent: "end", gap: "12px", position: "relative", paddingTop: 0 }}>
                <Button
                    disabled={!isChangeRequest}
                    onClick={cancelBlackoutDates}
                    variant="outlined"
                    className="navigate-cancel-button btn-active"
                    // color="error"
                    size="small"
                    sx={{ minWidth: "auto", lineHeight: "unset" }}
                    style={isSaving ? { pointerEvents: "none" } : {}}
                >
                    Discard Changes
                </Button>
                {isSaving ?
                    <Button
                        disabled
                        variant="outlined"
                        size="small"
                        className="navigate-save-button btn-active"
                        sx={{ minWidth: "auto", lineHeight: "unset", gap: 1, pointerEvents: "none", width: "71.58px", height: "30.2px" }}
                    >
                        <CircularProgress color="inherit" size={16} />
                    </Button>
                    :
                    usrReadyOnlyStatus ?
                        <Tooltip title={getPermissionMessage(userLoginType)} arrow followCursor>
                            <Button
                                variant="outlined"
                                size="small"
                                className="navigate-save-button"
                                sx={{ minWidth: "auto", lineHeight: "unset" }}
                                style={isSaving ? { pointerEvents: "none" } : {}}
                            > Save </Button></Tooltip> : <Button
                                disabled={!isChangeRequest}
                                onClick={saveBlackoutDates}
                                variant="outlined"
                                size="small"
                                className="navigate-save-button btn-active"
                                sx={{ minWidth: "auto", lineHeight: "unset" }}
                                style={isSaving ? { pointerEvents: "none" } : {}}
                            >
                            Save
                        </Button>
                }
            </Box>

        </Box>
    );
}

export { DemandSeasons, BlackoutDates }